import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";

const PublicLayout = () => {
  return (
    <>
      <Suspense>
        <main className="container-fluid">
          <Outlet />
        </main>
      </Suspense>
    </>
  )
}
export default PublicLayout